import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useTranslationAPI } from '../../../translations';
import classes from './styles/cookieAccept.module.scss';
import { codes } from '../../../../data/translations';
import { setBodyPaddingStyles, toggleBodyClass } from './utils';
import { useUserPageContextAPI } from '../../../user';
import useResizeObserver from 'use-resize-observer';
import { Close } from '../../../../components/Icons/Close';

if (window.ResizeObserver === undefined) {
	window.ResizeObserver = ResizeObserver;
}

export function CookieAccept() {
	const componentClasses = classNames(classes.container);
	const { ref, height = 0 } = useResizeObserver<HTMLDivElement>();
	const { acceptCookie } = useUserPageContextAPI();
	const { translate } = useTranslationAPI();
	const handleClose = () => {
		acceptCookie();
	};

	useEffect(() => {
		setBodyPaddingStyles(`${height}px`);
	}, [height]);

	useEffect(() => {
		toggleBodyClass(true);

		return () => {
			toggleBodyClass(false);
			setBodyPaddingStyles();
		};
	}, []);

	return (
		<div
			className={componentClasses}
			ref={ref}
		>
			<div className={classes.content}>
				<div className={`${classes.attention} metro-color`}>*</div>
				<div
					className={classes.message}
					// eslint-disable-next-line
					dangerouslySetInnerHTML={{ __html: translate(codes.cookieAcceptMessage) }}
				/>
				<button
					type='button'
					className={classes.button}
					onClick={handleClose}
				>
					<Close fill='#ffffff' />
				</button>
			</div>
		</div>
	);
}
